'use strict';

/**
 * DO NOT MODIFY
 * Generated from yarn nx run illustrations:sync
 */

/**
 * Currently used on web for interpolating the URL to CDN hosted asset using the name and version number.
 *
 * For example, given the following SpotSquare versionMap, '{ someIllustration: 2 }', and
 * JSX such as '<SpotSquare name="someIllustration />' will result in an image with the following URL:
 *
 * 'https://static-assets.coinbase.com/design-system/illustrations/spotSquare/light/someIllustration-2.svg
 *
 * In addition, this file is used to populate SpotSquare stories in percy, so the sort order based on createdAt is important.
 */
const versionMap = {
  coinbaseOneLogo: 3,
  referralsPeople: 3,
  frameEmpty: 4,
  boostedCard: 4,
  unsupportedAsset: 3,
  bridging: 2,
  dappWallet: 3,
  offersEmpty: 4,
  linkCoinbaseWallet: 2,
  pixBankDeposits: 4,
  pixDeposits: 4,
  coinbaseOneStakeOrWrap: 2,
  coinbaseOneStarToken: 2,
  wrapEth: 3,
  earnInterestOnCryptocurrency: 4,
  retailUSDCRewards: 3,
  coinbaseOneRewards: 3,
  coinbaseOneTokenRewards: 3,
  multipleAccountsWalletsForOneUser: 3,
  optInPushNotificationsEmail: 3,
  backedByUsDollar: 3,
  browserExtension: 2,
  collectingNfts: 3,
  crossBorderPayments: 4,
  cryptoAssets: 4,
  defiDecentralizedTradingExchange: 3,
  decentralization: 3,
  decentralizedWebWeb3: 3,
  digitalCollectibles: 3,
  earn: 4,
  globalTransactions: 4,
  insuranceProtection: 3,
  invest: 3,
  linkingYourWalletToYourCoinbaseAccount: 3,
  multiPlatformMobileAppBrowserExtension: 3,
  multicoinSupport: 4,
  noFees: 3,
  p2pPayments: 3,
  poweredByEthereum: 4,
  secureAndTrusted: 3,
  secureGlobalTransactions: 3,
  secureStorage: 3,
  stableValue: 3,
  staking: 3,
  selfCustody: 2,
  startToday: 3,
  stayInControlSelfHostedWalletsStorage: 3,
  walletSecurity: 3,
  watchVideos: 3,
  advancedTradingChartsIndicatorsCandles: 2,
  borrowWallet: 3,
  congratulationsOnEarningCrypto: 4,
  cryptoForBeginners: 4,
  semiCustodial: 4,
  earnToLearn: 3,
  gainsAndLosses: 3,
  gasFeesNetworkFees: 4,
  cryptoPortfolio: 3,
  addEth: 3,
  cryptoEconomy: 3,
  sidechain: 2,
  blockchain: 4,
  layeredNetworks: 3,
  stressTestedColdStorage: 2,
  cbEthWrappingUnavailable: 2,
  quickAndSimple: 4,
  hardwareWallets: 2,
  getStartedInMinutes: 4,
  basedInUsa: 3,
  completeAQuiz: 3,
  trendingHotAssets: 2,
  cryptoWallet: 4,
  taxesDetails: 3,
  didDecentralizedIdentity: 4,
  shareOnSocialMedia: 3,
  coinbaseOneStaking: 2,
  defiDecentralizedBorrowingLending: 2,
  ethStakeOrWrap: 3,
  ethStaking: 3,
  moneyDecentralized: 3,
  mining: 2,
  primeEarn: 4,
  assetForward: 4,
  nuxPopularAssets: 4,
  assetRefresh: 4,
  walletApp: 5,
  transferringCrypto: 5,
  rewardExpiring: 4,
  recommendInvestments: 4,
  nuxEarnYield: 5,
  nuxChecklist: 5,
  nft: 5,
  guideStartInvesting: 4,
  guideCryptoBeginner: 4,
  guideBullCase: 3,
  defiEarnAnnouncement: 5,
  cryptoApps: 6,
  confirmIDCard: 4,
  confirmAddress: 4,
  coinbaseCardSparkle: 4,
  announcementAdvancedTrading: 4,
  giftBoxCrypto: 5,
  fileYourCryptoTaxesOther: 4,
  futures: 4,
  phoneNotifications: 5,
  ethStakingRewards: 3,
  taxDocuments: 4,
  nuxEarnCrypto: 4,
  directDepositExcitement: 4,
  yieldCenter: 5,
  cardDeclined: 3,
  priceAlerts: 4,
  nftTag: 4,
  starToken: 4,
  confirmEmail: 4,
  addMultipleCrypto: 5,
  moneyRewards: 5,
  cardAnnouncement: 4,
  miniGift: 4,
  guideFiveThings: 4,
  nuxRecurringBuys: 4,
  interestForYou: 5,
  confirmSocialSecurity: 4,
  cardShipped: 4,
  sparkleToken: 5,
  encryptedEverything: 3,
  waitlistSignup: 4,
  switchReward: 4,
  portfolioPerformance: 3,
  guideNftDefi: 4,
  gifting: 5,
  eth2SendSell: 3,
  defiNfts: 4,
  darkModeIntroduction: 4,
  addPasswordProtection: 4,
  addCard: 3,
  cardAutoReload: 4,
  fileYourCryptoTaxesCheckOther: 4,
  bullishCase: 4,
  refreshMobileApp: 4,
  saveTheDate: 4,
  sendCryptoFaster: 4,
  borrowLimitsAddressed: 5,
  performance: 4,
  cardBlocked: 4,
  primeDeFi: 4,
  primeStaking: 4,
  swapEth: 3,
  ethStakeOrWrapTwo: 2,
  coinbaseOneSavingFunds: 2,
  documentCertified: 2,
  advancedTrading: 2,
  defiEarn: 2,
  tradeImmediately: 2,
  commerceInvoices: 2,
  openEmail: 1,
  addPhoneNumber: 2,
  verifyEmail: 2,
  advancedTradingUi: 2,
  verifyInfo: 2,
  readyToTrade: 2,
  coinbaseCardLock: 2,
  freeBtc: 2,
  onTheList: 2,
  holdCrypto: 2,
  commerceAccounting: 2,
  coinbaseCardPocket: 2,
  phoneNumber: 1,
  estimatedAmount: 2,
  cryptoAndMore: 3,
  walletNotifications: 2,
  documentSuccess: 2,
  accessToAdvancedCharts: 2,
  coinbaseOneDiscountedAmount: 2,
  automaticPayments: 2,
  notificationsAlt: 2,
  defiRisk: 2,
  contactsListWarning: 2,
  focusLimitOrders: 2,
  coinbaseFees: 2,
  defiHow: 2,
  appTrackingTransparency: 2,
  bigBtc: 3,
  earnInterest: 2,
  securityShield: 2,
  switchAdvancedToSimpleTrading: 2,
  holdingCrypto: 2,
  coinbaseOneUSDC: 0,
  noPortfolio: 0,
  yieldCenterUSDC: 0
};
module.exports = versionMap;
//# sourceMappingURL=versionMap.js.map
